export default {
  API_BASE_URL: 'http://localhost:3344',
};
